import { createDownloadUrl, escapeXml, roundCoordinate } from "./utils.js";

export class GPXExporter {
  download(points, fileName = "planned-route.gpx") {
    if (!Array.isArray(points) || points.length < 2) {
      throw new Error("Add at least two route points before exporting GPX.");
    }

    const url = createDownloadUrl(buildGpx(points), "application/gpx+xml;charset=utf-8");
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.style.display = "none";
    document.body.append(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}

function buildGpx(points) {
  const generatedAt = new Date().toISOString();
  const trackPoints = points.map(formatTrackPoint).join("\n");

  return `<?xml version="1.0" encoding="UTF-8"?>
<gpx version="1.1" creator="BH GPX Route Planner" xmlns="http://www.topografix.com/GPX/1/1" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd">
  <metadata>
    <time>${escapeXml(generatedAt)}</time>
  </metadata>
  <trk>
    <name>Planned route</name>
    <trkseg>
${trackPoints}
    </trkseg>
  </trk>
</gpx>
`;
}

function formatTrackPoint(point) {
  const elevation = Number.isFinite(point.elevation) ? `\n        <ele>${roundCoordinate(point.elevation)}</ele>` : "";
  return `      <trkpt lat="${roundCoordinate(point.latitude)}" lon="${roundCoordinate(point.longitude)}">${elevation}\n      </trkpt>`;
}
